
import React from 'react';
import { SimulationConfig, RenderLayer } from './types';
import { SectionLabel } from './SectionLabel';

interface LayerSortingSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const LayerSortingSection: React.FC<LayerSortingSectionProps> = ({ config, setConfig }) => {
  const moveLayer = (index: number, direction: 'UP' | 'DOWN') => {
    const newOrder = [...(config.renderOrder || ['WALLS', 'RINGS', 'TRAIL', 'BLAST', 'FX', 'BALL'])];
    if (direction === 'UP') {
      if (index === 0) return;
      [newOrder[index - 1], newOrder[index]] = [newOrder[index], newOrder[index - 1]];
    } else {
      if (index === newOrder.length - 1) return;
      [newOrder[index], newOrder[index + 1]] = [newOrder[index + 1], newOrder[index]];
    }
    setConfig(p => ({ ...p, renderOrder: newOrder }));
  };

  const getLabel = (layer: RenderLayer) => {
      switch(layer) {
          case 'WALLS': return 'Container Walls';
          case 'RINGS': return 'Escape Rings';
          case 'TRAIL': return 'Trails & Lines';
          case 'BALL': return 'Physics Spheres';
          case 'FX': return 'Collision Ripple FX';
          case 'BLAST': return 'Broken Shards (Blast)';
      }
  };

  const currentOrder = config.renderOrder || ['WALLS', 'RINGS', 'TRAIL', 'BLAST', 'FX', 'BALL'];

  return (
    <div className="w-full flex flex-col gap-3 p-4 rounded-3xl border bg-gray-500/5 border-gray-500/20 mb-4">
      <SectionLabel icon="fa-layer-group" darkMode={config.darkMode}>Render Layer Priority</SectionLabel>
      <div className="flex flex-col gap-1.5">
          <span className="text-[8px] opacity-50 text-center mb-1 uppercase font-black">Top (Front)</span>
          {[...currentOrder].reverse().map((layer, reverseIdx) => {
              const actualIdx = currentOrder.length - 1 - reverseIdx;
              return (
                  <div key={layer} className={`flex items-center justify-between p-2 rounded-xl border transition-all ${config.darkMode ? 'bg-neutral-800 border-neutral-700' : 'bg-white border-neutral-200'}`}>
                      <span className="text-[9px] font-black uppercase">{getLabel(layer)}</span>
                      <div className="flex gap-1">
                          <button 
                            onClick={() => moveLayer(actualIdx, 'DOWN')} // Visual Up is Array End (Down index)
                            disabled={actualIdx === currentOrder.length - 1}
                            className="w-6 h-6 flex items-center justify-center rounded bg-black/10 hover:bg-black/20 disabled:opacity-20"
                          >
                              <i className="fa-solid fa-arrow-up text-[8px]"></i>
                          </button>
                          <button 
                            onClick={() => moveLayer(actualIdx, 'UP')} // Visual Down is Array Start (Up index)
                            disabled={actualIdx === 0}
                            className="w-6 h-6 flex items-center justify-center rounded bg-black/10 hover:bg-black/20 disabled:opacity-20"
                          >
                              <i className="fa-solid fa-arrow-down text-[8px]"></i>
                          </button>
                      </div>
                  </div>
              );
          })}
          <span className="text-[8px] opacity-50 text-center mt-1 uppercase font-black">Bottom (Back)</span>
      </div>
    </div>
  );
};
